import axios from '../lib/axios';
// import axiosApiInstance from '../lib/axios';

export const login = (data) => {
  return axios.post('/auth/login', data);
};

export const requestLoginCode = (data) => {
  return axios.post('/auth/login-code-request', data);
};

export const loginWithCode = (data) => {
  return axios.post('/auth/login-code', data);
};

export const register = (data) => {
  return axios.post('/suppliers/registration', data);
};

export const verify = (data) => {
  return axios.post('/auth/verification', data);
};

export const requestPass = (data) => {
  return axios.post('/auth/password-recovery-request', data);
};

export const confirmPass = (data) => {
  return axios.post('/auth/password-recovery-confirmation', data);
};



export const logout = () => {
  return axios.post('/auth/logout');
};
